import React, { useContext } from 'react';
import { MenuItem, TextField } from '@material-ui/core';

import { FormContext } from './FormContext';
import { useFormField, type IFormFieldProps } from './useFormField';

interface IFormDropdownProps extends IFormFieldProps<string> {
    items: Array<{ label: string; value: string }>;
}

export const FormDropdown: React.FC<IFormDropdownProps> = (props) => {
    const { name, title, validators, items, ...rest } = props;

    const { handleChange, hasError, getHelperText, formValue } =
        useFormField<string>(props);

    const context = useContext(FormContext);

    return (
        <TextField
            {...rest}
            select={true}
            id={name}
            name={name}
            label={title}
            value={formValue}
            error={hasError()}
            onChange={handleChange(name, validators)}
            margin="normal"
            helperText={getHelperText()}
            disabled={context.formDisabled}
            InputProps={{
                className: 'Form__Field Form__Dropdown',
            }}
        >
            {items.map((option: { label: string; value: string }) => (
                <MenuItem key={option.label} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );
};
